// AYUME — ouvre le comparatif des formes et longueurs. Indépendant du configurateur et du panier.
if (!window.ayumeCompareReady) {
  window.ayumeCompareReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ayume-compare]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.ayumeCompare);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    // Un clic sur le fond (hors du contenu) ferme la fenêtre.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('ayume-compare-dialog')) event.target.close();
  });
}
